import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/core.user.service';
import { SiteConfigService } from '../../services/core.site-config.service';
import { PageContextService } from '../../services/core.page-context.service';
import { doGetPromise } from '../../config/core.httpclient-utils';

import * as $ from 'jquery';
import * as _ from 'lodash-es';

@Component({
    selector: 'gf-footer',
    template: require('./footer.html')
})
export class FooterComponent implements OnInit, OnDestroy {
    @Input() siteConfig: any = { };

    showApiDocs: boolean = false;
    isCollapsed: boolean = false;

    private userHasCollapsed: boolean = false;
    private lastStateName: string | null = null;
    private contextSub: Subscription;

    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
        private siteConfigService: SiteConfigService,
        private stateService: StateService,
        private pageContextService: PageContextService
    ) {
    }

    ngOnInit() {
        if (!this.siteConfig || Object.keys(this.siteConfig).length === 0) {
            this.siteConfig = this.siteConfigService.getSiteConfig() || {};
        }

        var customFooterUrl = _.get(this.siteConfig, 'customFooterUrl', '');
        var environment = _.get(this.siteConfig, 'appEnvironment', 'production');
        if (customFooterUrl != '' && environment != 'development') {
            doGetPromise(this.httpClient, customFooterUrl)
                .then(
                    (result) => {
                        if (_.get(result, 'status', '') == 200) {
                            $("#site-footer").prepend(_.get(result, 'data', ''));
                        }
                    }, (result) => {
                        console.log(result);
                    }
                );
        }
        this.showApiDocs = this.shouldShowApiDocs();

        this.applyAutoCollapse();
        this.contextSub = this.pageContextService.contextChanged$.subscribe(
            () => this.applyAutoCollapse()
        );
    }

    ngOnDestroy() {
        if (this.contextSub) { this.contextSub.unsubscribe(); }
    }

    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        this.userHasCollapsed = this.isCollapsed;
    }

    shouldShowApiDocs() {
        const showApiDocs = _.get(this.siteConfig, 'showApiDocs', 2);

        if (showApiDocs == 0) {
            return true;
        }

        if (showApiDocs == 1 && this.userService.hasUser()) {
            return true;
        }

        // Setting is 2 (never), or no user
        return false;
    }

    private applyAutoCollapse() {
        const currentName = this.stateService.current.name || '';
        const stateChanged = currentName !== this.lastStateName;
        this.lastStateName = currentName;

        if (!stateChanged) return;

        const routeCollapse = !!((this.stateService.current.data || {}) as any).collapseFooter;
        if (routeCollapse) {
            this.isCollapsed = true;
        } else if (!this.userHasCollapsed) {
            this.isCollapsed = false;
        }
    }
}
